import React, { useState, useRef } from 'react';
import StatsGeneral from './StatsGeneral';
import StatsAdvanced from './StatsAdvanced';
import './StatsPage.css';

function StatsPage({ match, onBack }) {
  console.log('🔴🔴🔴 STATSPAGE MONTÉE 🔴🔴🔴');
  console.log('Match reçu:', match);
  const [activeTab, setActiveTab] = useState(0);
  const statsAdvancedRef = useRef(null);

  const handleOpenPdfModal = () => {
    console.log('🔍 DEBUG - statsAdvancedRef.current:', statsAdvancedRef.current);
    
    if (statsAdvancedRef.current) {
      console.log('✅ La ref existe');
      statsAdvancedRef.current.openPdfModal();
    } else {
      console.error('❌ La ref est null - Le composant n\'est pas monté');
      // Attendre un peu et réessayer
      setTimeout(() => {
        console.log('🔄 Nouvelle tentative...');
        if (statsAdvancedRef.current) {
          statsAdvancedRef.current.openPdfModal();
        } else {
          console.error('❌ Toujours null après délai');
        }
      }, 300);
    }
  };

  return (
    <div className="stats-container">
      {/* Header avec bouton retour, titre et bouton PDF */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '-5px'
      }}>
        <button className="stats-back-btn" onClick={onBack}>
          ← Retour
        </button>
        
        <h1 className="stats-header" style={{ margin: 0, marginBottom: '25px' }}>
          Statistiques
        </h1>
        
        {/* Bouton PDF */}
        <button 
          className="pdf-button-compact"
          onClick={handleOpenPdfModal}
          title="Générer un rapport PDF"
          style={{
            background: 'linear-gradient(135deg, #E91E63, #C2185B)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '8px 20px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(233, 30, 99, 0.3)',
            transition: 'all 0.3s',
            marginBottom: '25px'
          }}
        >
          📄 PDF
        </button>
      </div>

      {/* Onglets Statistiques 1 / 2 */}
      <div style={{ 
        display: 'flex', 
        gap: '8px', 
        marginBottom: '0px',
        borderBottom: '2px solid #e0e0e0'
      }}>
        <button
          onClick={() => setActiveTab(0)}
          style={{
            padding: '12px 24px',
            border: 'none',
            borderBottom: activeTab === 0 ? '3px solid #1976d2' : '3px solid transparent',
            backgroundColor: 'transparent',
            color: activeTab === 0 ? '#1976d2' : '#666',
            fontWeight: activeTab === 0 ? '600' : '400',
            fontSize: '15px',
            cursor: 'pointer',
            transition: 'all 0.3s'
          }}
        >
          Stats générales
        </button>
        <button
          onClick={() => setActiveTab(1)}
          style={{
            padding: '12px 24px',
            border: 'none',
            borderBottom: activeTab === 1 ? '3px solid #1976d2' : '3px solid transparent',
            backgroundColor: 'transparent',
            color: activeTab === 1 ? '#1976d2' : '#666',
            fontWeight: activeTab === 1 ? '600' : '400',
            fontSize: '15px',
            cursor: 'pointer',
            transition: 'all 0.3s'
          }}
        >
          Stats avancées
        </button>
      </div>

      {/* IMPORTANT : Les DEUX composants sont montés en permanence 
          On utilise display: none/block pour les cacher/afficher
          Cela permet au bouton PDF de fonctionner depuis n'importe quel onglet */}
      <div style={{ display: activeTab === 0 ? 'block' : 'none' }}>
        <StatsGeneral match={match} />
      </div>
      <div style={{ display: activeTab === 1 ? 'block' : 'none' }}>
        <StatsAdvanced ref={statsAdvancedRef} match={match} />
      </div>
    </div>
  );
}

export default StatsPage;